// KAMPSPORT KIDS READY™ — Swedish copy of MARTIAL ARTS KIDS CLASS READY™ (the winner), translated from the Dutch copy
// (which is the German copy of the English v3 that sells). Same structure, palette and angles. Sweden, "du".
// All copy and links live here. Image URLs live in data/images.ts, the pixel in data/pixel.ts.
// Promise (must match ads, checkout and the PDF): 52-week plan + 10 complete 45-minute kids classes ("pass"),
// 299 kr one-time, 10-day guarantee, the 5 bonuses in the checkout order.
// Values = the checkout (Markets, Sverige SEK): main 1 799 kr; bonuses 399, 299, 299, 299, 399 kr (1 695 kr);
// total 3 494 kr -> 299 kr, you save 3 195 kr.
// Terms follow productos/martial-arts-kids-sv/glosario.md. Class, game, drill, quarter and page names match the
// Swedish Gamma prompt (prompts/martial-arts-kids-class-ready-sv.md).
// Kids + contact sport: no promises about self-defense, belts or sign-ups; mitts and air only, no sparring; no testimonials.
// ­ = soft hyphen (long Swedish compounds can break on a 375 px screen).   = no-break space ("299 kr").

export { META_PIXEL_ID } from './pixel';
export const CHECKOUT_URL = 'https://kampsport-kids-ready.impultienda.ar/checkout';

export const PAGE_TITLE = 'Kampsport Kids Ready™ – Hela ditt år med barnträningar, färdigplanerat';
export const META_DESCRIPTION =
  'En 52-veckorsplan plus 10 kompletta träningspass för barn på 45 minuter, redo att köra. Slå upp veckans sida, förbered dig på 5 minuter och kör passet redan i dag.';

// GLOBAL
export const brand = 'KAMPSPORT KIDS READY™';
/** Label for every button that scrolls to the offer section */
export const ctaLabel = 'PLANERA HELA MITT ÅR';
export const ctaMicrocopy = 'Direkt som pdf · Engångsbetalning 299 kr · 10 dagars garanti';
export const stickyLabel = 'PLANERA MITT ÅR · 299 KR';
export const topBarMobileLabel = 'BOKEN · 299 KR';
export const price = '299 kr';

// 1. HERO (buyer line, title, short subtitle, mockup, button)
export const hero = {
  eyebrow: 'FÖR TRÄNARE I KARATE, TAEKWONDO, KICKBOXNING OCH THAIBOXNING',
  titleLead: 'HELA DITT ÅR MED BARN­TRÄNINGAR,',
  titleHighlight: 'FÄRDIG­PLANERAT.',
  sub: 'En 52-veckorsplan plus 10 kompletta träningspass för barn på 45 minuter, redo att köra. Slå upp veckans sida och kör passet redan i dag.',
  mockupAlt: 'Kampsport Kids Ready™ på en datorskärm, med de 5 bonusarna på surfplattor och mobiler',
};

// 2. STATS
export const stats = [
  { value: '52', label: 'VECKOR PLANERADE' },
  { value: '10', label: 'KOMPLETTA PASS' },
  { value: '45', label: 'MINUTER MED TIDSSCHEMA' },
  { value: '3', label: 'ÅLDERSNIVÅER I VARJE PASS' },
];

// 2b. BEFORE / AFTER
export const beforeAfter = {
  title: 'KVÄLLEN INNAN VS. PÅ MATTAN.',
  before: {
    label: 'FÖRE',
    when: 'Kvällen innan',
    quote: '”Vad ska jag göra med barnen i kväll?”',
    items: ['Letar övningar i videoklipp.', 'Samma slagövning igen.', 'De minsta tappar fokus, de äldre har tråkigt.'],
  },
  after: {
    label: 'EFTER',
    when: 'På mattan',
    items: ['Slå upp veckans sida.', 'Förbered dig på 5 minuter.', 'Kör passet på 45 minuter.', 'Hälsa ut och skicka föräldrainfon.'],
  },
};

// 3. WHAT DOES YOUR CLASS NEED THIS WEEK (pick a need, see the class that is ready for it)
const block = 'Passets upplägg: hälsning & uppvärmningslek 8 · teknik 12 · mitts- & partnerövningar 12 · avslutningslek 8 · nedvarvning & värdestund 5';
export const selector = {
  eyebrow: 'BÖRJA DÄR DINA BARN ÄR NU',
  title: 'VAD BEHÖVER DIN BARNGRUPP DEN HÄR VECKAN?',
  sub: 'Välj ett tema och se passet som redan är klart för det.',
  startLabel: 'DITT NÄSTA PASS',
  tablistLabel: 'Teman för passen',
  columns: ['SIDA 1 · PASSPLANERING', 'SIDA 2 · SÅ FÖRKLARAR DU', 'SIDA 3 · ÖVNINGAR & LEK'],
  note: 'Alla 10 pass har samma upplägg på 3 sidor. Anpassa varje pass efter din stil och din dojos säkerhetsregler.',
  items: [
    {
      tab: 'En stark start: hållning & respekt',
      n: 'PASS 01 · VECKA 1',
      title: 'Hållning, gard & respekt i dojon',
      goal: 'Barnet hälsar, står i en stabil kampställning med hög gard och går tillbaka till klarpositionen på kommando.',
      open: ['Passets mål, utrustning och förberedelse på 5 minuter', 'Dina inledande ord: ”Fötterna isär, ena foten bakåt. Händerna högt vid ansiktet. Det är din gard!”', block],
      activity: ['5 tekniksteg med de viktiga punkterna: ställning, hälsning, klarposition, kampställning, gard', '3 kort ”Så rättar du det”, till exempel ”Tågräls, inte lina!”', 'Kort för åldersnivå: så funkar det med 4–6, 7–9 och 10–12 år'],
      close: ['2 övningar med mattskiss: Ställningskoll och Studsa & frys', 'Avslutningslek: Dojon säger', 'Värdestund (Respekt), föräldrainfo och streckgradering'],
    },
    {
      tab: 'Sparkar med balans',
      n: 'PASS 03 · VECKA 9',
      title: 'Framspark & balans',
      goal: 'Barnet lyfter knät, sparkar framåt med trampdynan och sätter ner foten kontrollerat i ställningen.',
      open: ['Passets mål, utrustning och förberedelse på 5 minuter', 'Dina inledande ord: ”Knä upp … spark … knä tillbaka … fot ner. Garden stannar uppe!”', block],
      activity: ['Tekniksteg med de viktiga punkterna, från knä upp till fot ner', '3 kort ”Så rättar du det” för de vanligaste felen i sparken', 'Kort för åldersnivå för 4–6, 7–9 och 10–12 år'],
      close: ['2 övningar på sparkdynan, med mattskiss och tider', 'Avslutningslek: Trafikljuset', 'Värdestund (Självkontroll), föräldrainfo och streckgradering'],
    },
    {
      tab: 'Kombinationer på mittsarna',
      n: 'PASS 06 · VECKA 22',
      title: 'Slag­kombinationer på mittsarna',
      goal: 'Barnet slår en kombination på 3 (jabb, cross, krok) på mittsarna och går tillbaka till garden.',
      open: ['Passets mål, utrustning och förberedelse på 5 minuter', 'Dina inledande ord: ”1 är jabb, 2 är cross, 3 är krok. Redo? 1-2-3 … gard!”', block],
      activity: ['Tekniksteg för kroken och 1-2-3', 'Hur de äldre håller mittsarna säkert åt en partner', 'Kort för åldersnivå för 4–6, 7–9 och 10–12 år'],
      close: ['2 mittsövningar med mattskiss, ronder och tider', 'Avslutningslek: Kombinationskedjan', 'Värdestund (Samarbete), föräldrainfo och streckgradering'],
    },
    {
      tab: 'Säkerhet & frigöringar från grepp',
      n: 'PASS 09 · VECKA 35',
      title: 'Frigöringar från grepp & trygg med främlingar',
      goal: 'Barnet frigör sig från ett mjukt handledsgrepp, tar ett steg bakåt, använder en stark röst och vet att det sedan springer till en trygg vuxen och berättar vad som hänt.',
      open: ['Passets mål, utrustning och förberedelse på 5 minuter', 'Dina inledande ord: dra loss, steg bakåt, stark röst, spring till en trygg vuxen', block],
      activity: ['Enkla frigöringssteg, som övas långsamt och mjukt', 'Säkerhetsreglerna: stanna med din grupp, använd din röst, berätta för en trygg vuxen', 'Kort för åldersnivå för 4–6, 7–9 och 10–12 år'],
      close: ['2 lugna övningar med mattskiss', 'Avslutningslek: Stafett med stark röst', 'Värdestund (Säkerhet), föräldrainfo och streckgradering'],
    },
  ],
};

// 4. LOOK INSIDE (real pages of the book, in the same order as pageImages in data/images.ts)
export const lookInside = {
  eyebrow: 'RIKTIGA SIDOR. SE LAYOUTEN INNAN DU KÖPER.',
  title: 'DET HÄR LIGGER BREDVID DIN MATTA FRAMÖVER.',
  sub: 'Öppna varje sida i full storlek: din 52-veckorsplan, två passplaneringar, generalrepetitionen inför graderingen med bedömningsblad och din passplanerare.',
  hint: 'Svep för fler · Tryck på en sida för att se den stort',
  note: 'Det här är utvalda sidor, inte hela boken.',
  captions: [
    'Din 52-veckorsplan (kvartal 1)',
    'Pass 01 · Passplanering',
    'Pass 09 · Passplanering',
    'Pass 10 · Generalrepetition: stationer & upplägg',
    'Pass 10 · Bedömningsblad & ceremoni',
    'Passplanerare & strecköversikt',
  ],
};

// 5. THE SYSTEM
export const plan = {
  eyebrow: 'ETT SYSTEM FÖR VARJE PASS',
  title: 'HELA ÅRET ÄR PLANERAT. DU HÄLSAR IN OCH KÖR.',
  text: 'Varje vecka på året är planerad: starten på ett av de 10 kompletta passen, en färdig lek eller övning på 10 minuter, eller en streckgradering. Varje pass ger dig på 3 sidor passplaneringen, teknikstegen och övningarna med lek.',
  steps: [
    { title: 'SLÅ UPP', text: 'Hitta den här veckan i din 52-veckorsplan.' },
    { title: 'FÖRBERED', text: 'Läs sidan och gör i ordning mattan på 5 minuter.' },
    { title: 'KÖR', text: 'Uppvärmningslek, en teknik, mittsar och partner.' },
    { title: 'HÄLSA UT', text: 'Avslutningslek, värdestund och föräldrainfon.' },
  ],
  featuresTitle: 'I VARJE KOMPLETT PASS',
  features: [
    { icon: 'goal', title: 'Ett tydligt mål för passet', text: 'En mening om vad barnen ska göra, startveckan och vilka förkunskaper de behöver.' },
    { icon: 'timer', title: 'Ett pass på 45 minuter', text: 'Hälsning & uppvärmningslek 8 · Teknik 12 · Mitts- & partnerövningar 12 · Avslutningslek 8 · Nedvarvning & värdestund 5.' },
    { icon: 'steps', title: 'Tekniksteg + instruktioner', text: 'Numrerade steg med de viktiga punkterna, och exakt den instruktion som rättar de vanligaste felen.' },
    { icon: 'questions', title: '4–6, 7–9 och 10–12 år', text: 'Så kör du samma pass med alla åldrar på mattan, även i blandade grupper.' },
    { icon: 'quote', title: 'Dina ord, ordagrant', text: 'Inledande ord, kommandon och värdestunden, plus ett proffstips och ett vanligt fel.' },
    { icon: 'action', title: 'Övningar, lek + föräldrainfo', text: '2 övningar och en avslutningslek med mattskiss, en streckgradering och föräldrainfo att skicka direkt.' },
  ],
} as const;

// 5b. VALUES + AGE LEVELS
export const valuesBand = {
  eyebrow: 'MER ÄN SPARKAR OCH SLAG',
  title: 'ETT VÄRDE FÖR VARJE PASS. HELA ÅRET.',
  sub: 'Varje pass slutar med en kort värdestund, ordagrant utskriven, så att föräldrarna ser vad barnen tar med sig hem.',
  classWord: 'PASS',
  values: [
    { n: '01', value: 'Respekt' },
    { n: '02', value: 'Koncen­tration' },
    { n: '03', value: 'Själv­kontroll' },
    { n: '04', value: 'Ihärdighet' },
    { n: '05', value: 'Själv­förtroende' },
    { n: '06', value: 'Samarbete' },
    { n: '07', value: 'Upp­märksamhet' },
    { n: '08', value: 'Mod' },
    { n: '09', value: 'Säkerhet' },
    { n: '10', value: 'Disciplin' },
  ],
  agesTitle: 'VARJE PASS ANPASSAS TILL BARNEN FRAMFÖR DIG',
  ages: [
    { age: '4–6 ÅR', text: 'Golvmarkeringar, djurnamn, korta steg som de säger högt tillsammans och många lekar.' },
    { age: '7–9 ÅR', text: 'Hela tekniken på tränarens mittsar, byta sida på kommando.' },
    { age: '10–12 ÅR', text: 'Högre tempo, röra sig med garden uppe, hålla mittsarna åt en partner och hjälpa till att leda passet.' },
  ],
};

// 6. THE 52-WEEK PLAN (quarter names as printed in the book)
export const yearPlan = {
  eyebrow: 'DIN 52-VECKORSPLAN',
  title: 'HELA ÅRET, PLANERAT VECKA FÖR VECKA.',
  sub: 'Under ★-veckorna startar ett nytt pass. ◆-veckorna är streckgraderingar. Veckorna däremellan väntar en färdig lek eller övning på 10 minuter.',
  weekWord: 'VECKA',
  quarters: [
    {
      q: 'K1',
      weeks: 'VECKA 1–13',
      name: 'LÄGG GRUNDEN',
      full: [
        { week: '1', label: 'START PASS 01', title: 'Hållning, gard & respekt i dojon' },
        { week: '5', label: 'START PASS 02', title: 'Raka slag: jabb & cross' },
        { week: '9', label: 'START PASS 03', title: 'Framspark & balans' },
        { week: '13', label: 'STRECKGRADERING', title: 'Följ upp framstegen med passplaneraren', review: true },
      ],
      activities: '+ färdiga lekar och övningar på 10 minuter, som Staty i gard, Uppställning mot klockan och Stå som en flamingo.',
    },
    {
      q: 'K2',
      weeks: 'VECKA 14–26',
      name: 'TRÄFFA & FÖRSVARA',
      full: [
        { week: '14', label: 'START PASS 04', title: 'Rundspark' },
        { week: '18', label: 'START PASS 05', title: 'Block: högt, mellan & lågt' },
        { week: '22', label: 'START PASS 06', title: 'Slag­kombinationer på mittsarna' },
        { week: '26', label: 'STRECKGRADERING', title: 'Följ upp framstegen med passplaneraren', review: true },
      ],
      activities: '+ färdiga lekar och övningar på 10 minuter, som Vridklockan, Regnblock och Ropa kombinationen.',
    },
    {
      q: 'K3',
      weeks: 'VECKA 27–39',
      name: 'RÖR DIG & VAR TRYGG',
      full: [
        { week: '27', label: 'START PASS 07', title: 'Fotarbete & avstånd' },
        { week: '31', label: 'START PASS 08', title: 'Säkra fall' },
        { week: '35', label: 'START PASS 09', title: 'Frigöringar från grepp & trygg med främlingar' },
        { week: '39', label: 'STRECKGRADERING', title: 'Följ upp framstegen med passplaneraren', review: true },
      ],
      activities: '+ färdiga lekar och övningar på 10 minuter, som ”För nära, för långt”, Gungstolen och Trygga zonen.',
    },
    {
      q: 'K4',
      weeks: 'VECKA 40–52',
      name: 'SÄTT IHOP ALLT',
      full: [
        { week: '40', label: 'START PASS 10', title: 'Generalrepetition inför graderingen' },
        { week: '52', label: 'STRECKGRADERING', title: 'Streckgradering vid årets slut', review: true },
      ],
      activities: '+ färdiga lekar och övningar på 10 minuter, som Blockmästaren, Upp på scenen och Dojostafetten.',
    },
  ],
  toolsTitle: 'PLUS DINA VERKTYG SOM TRÄNARE',
  tools: ['När passet blir svårt: 8 situationer, vad du säger och vad du gör', 'Passplanerare & strecköversikt: planera varje pass på 5 minuter', 'Lathund för mattan'],
};

// 7. THE 10 COMPLETE CLASSES
export const meetings = {
  eyebrow: 'DE 10 KOMPLETTA PASSEN',
  title: 'TIO BARNPASS. REDO ATT KÖRA.',
  sub: 'Följ 52-veckorsplanen eller börja med passet som dina barn behöver just nu. Varje pass har 3 sidor: passplanering, så förklarar du, övningar & lek.',
  weekLabel: 'STARTVECKA',
  items: [
    { n: '01', week: '1', title: 'Hållning, gard & respekt i dojon', goal: 'Hälsa, en stabil kampställning med hög gard och klarpositionen på kommando.' },
    { n: '02', week: '5', title: 'Raka slag: jabb & cross', goal: 'Jabb och cross från garden, med handen tillbaka vid ansiktet varje gång.' },
    { n: '03', week: '9', title: 'Framspark & balans', goal: 'Knä upp, spark med trampdynan och kontrollerad landning i ställningen.' },
    { n: '04', week: '14', title: 'Rundspark', goal: 'Vrid stödfoten, knät upp åt sidan och en kontrollerad spark mot ett lågt eller mellanhögt mål.' },
    { n: '05', week: '18', title: 'Block: högt, mellan & lågt', goal: 'Tre block på kommando, med blicken på tränaren.' },
    { n: '06', week: '22', title: 'Slag­kombinationer på mittsarna', goal: 'En kombination på 3 slag (jabb, cross, krok) på mittsarna och tillbaka till garden.' },
    { n: '07', week: '27', title: 'Fotarbete & avstånd', goal: 'Röra sig framåt, bakåt och åt sidan utan att korsa fötterna, och hitta rätt avstånd.' },
    { n: '08', week: '31', title: 'Säkra fall', goal: 'Falla bakåt och åt sidan från en låg position, hakan mot bröstet, och resa sig säkert.' },
    { n: '09', week: '35', title: 'Frigöringar från grepp & trygg med främlingar', goal: 'Frigöra sig från ett mjukt handledsgrepp, använda den starka rösten och springa till en trygg vuxen.' },
    { n: '10', week: '40', title: 'Generalrepetition inför graderingen', goal: 'En lugn provgradering med årets tekniker, ett bedömningsblad och texten till ceremonin.' },
  ],
  cta: 'HÄMTA ALLA 10 PASS + 5 BONUSAR',
  ctaMicrocopy: '299 kr · Engångsbetalning',
};

// 8. BONUSES (same order and values as the checkout)
export const bonuses = {
  eyebrow: '5 BONUSAR INGÅR I DIN BOK FÖR 299 KR',
  title: 'ALLT ANNAT SOM DINA BARNPASS BEHÖVER.',
  sub: 'Lekar, graderingar, meddelanden till föräldrar, mittsövningar och en plan för provträningen, redo att använda.',
  valueWord: 'VÄRDE',
  free: 'INGÅR',
  coverWord: 'Omslag',
  totalNote: '1 695 kr i bonusar, utan extra kostnad',
  items: [
    {
      label: 'BONUS 01',
      value: '399 kr',
      short: '60 kampsportslekar för barn',
      hook: 'Aldrig mer utan lekidéer.',
      title: '60 kampsports­lekar för barn – helt utan utrustning',
      text: '60 roliga, säkra lekar för att starta varje pass, få ut energi och avsluta, sorterade efter mål: uppvärmning, reaktion, balans, koncentration, sparkar och slag, samarbete och nedvarvning. Var och en med uppställning, regler, tid och ett säkerhetstips.',
    },
    {
      label: 'BONUS 02',
      value: '299 kr',
      short: 'Graderingskit',
      hook: 'Lugna, välorganiserade graderingar.',
      title: 'Graderingskit – krav, graderingsschema & diplom att skriva ut',
      text: 'En exempelchecklista med kraven för varje bälte (anpassa efter din stil), ett bedömningsblad, ett graderingsschema med tider, vad du säger vid öppningen och avslutningen, en strecköversikt och diplom att skriva ut.',
    },
    {
      label: 'BONUS 03',
      value: '299 kr',
      short: 'Föräldrapaket',
      hook: 'Du vet exakt vad du ska skicka till familjerna.',
      title: 'Föräldra­paket – välkomstbrev, dojoregler & färdiga meddelanden',
      text: 'Ett välkomstbrev för nya barn, dojoregler för barn på en sida, en checklista ”Vad tar jag med?”, utskick inför graderingar, ett månadsbrev om månadens värde, meddelanden vid missade pass och stöd för lugna samtal med föräldrar.',
    },
    {
      label: 'BONUS 04',
      value: '299 kr',
      short: '50 mitts- & partnerövningar',
      hook: 'Nytt arbete på mittsarna varje pass.',
      title: '50 mitts- & partner­övningar – för varje barnträning',
      text: '50 övningar med mittsar, sparkdynor och partner för slag, sparkar, block, kombinationer, fotarbete och reaktion. Var och en med uppställning, ronder och tider, hur man håller mittsarna och ett säkerhetstips.',
    },
    {
      label: 'BONUS 05',
      value: '399 kr',
      short: 'Provträningsguiden',
      hook: 'Så att varje första träning räknas.',
      title: 'Provträningsguiden – en första träning som barn och föräldrar minns',
      text: 'Hur du tar emot familjen i dörren, en provträning på 30 minuter med lekar och en första teknik som alla barn klarar, vad du säger i slutet och färdiga meddelanden för dagarna efter.',
    },
  ],
};

// 9. OFFER
export const offer = {
  eyebrow: 'DITT NÄSTA PASS BÖRJAR HÄR',
  title: 'HELA DITT ÅR MED BARNTRÄNINGAR. I EN BOK.',
  kicker: 'HELA DEN DIGITALA BOKEN',
  name: 'Kampsport Kids Ready™',
  description: 'En 52-veckorsplan och 10 kompletta träningspass för barn på 45 minuter, redo att köra, plus fem bonusar: lekar, ett graderingskit, meddelanden till föräldrar, mittsövningar och en guide för provträningen.',
  mockupAlt: 'Allt som ingår i Kampsport Kids Ready™',
  includedTitle: 'DIN BOK INNEHÅLLER',
  included: [
    '52-veckorsplan: hela året planerat',
    '10 kompletta barnpass med 3 sidor vardera',
    'Ett pass på 45 minuter med tider i varje pass',
    'Tekniksteg, viktiga punkter och instruktioner vid fel',
    '4–6, 7–9 och 10–12 år i varje pass',
    'Övningar, avslutningslek, värdestund och föräldrainfo',
    'Verktyg som tränare: svåra stunder, passplanerare, lathund',
  ],
  /** Value stack: exactly the checkout prices (SEK) */
  stackTitle: 'DET HÄR FÅR DU',
  mainItem: { label: 'Kampsport Kids Ready™ (52-veckorsplan + 10 kompletta pass)', value: '1 799 kr' },
  totalLabel: 'Totalt värde',
  totalValue: '3 494 kr',
  todayLabel: 'I DAG',
  priceNote: 'Engångsbetalning · Under 6 kr i veckan',
  saveNote: 'Du sparar 3 195 kr',
  /** The ONLY button that goes to checkout */
  cta: 'JA, SKICKA MIG BOKEN – 299 KR',
  ctaNote: ['Vidare till säker betalning', 'Tillgång via e-post efter betalningen'],
  format: 'Pdf på svenska. Digital leverans. Anpassa varje pass efter din stil, din dojos säkerhetsregler och dina barns ålder och nivå.',
  guaranteeNote: '10 dagars nöjd-kund-garanti, pengarna tillbaka',
};

// 10. GUARANTEE
export const guarantee = {
  sealTop: '10',
  sealBottom: 'DAGARS GARANTI',
  title: '10 DAGARS PENGARNA-TILLBAKA-GARANTI. INGA FRÅGOR.',
  text: 'Kör dina nästa pass med boken. Är den ändå inget för dig? Mejla support@stockdigital.shop inom 10 dagar efter köpet så får du pengarna tillbaka.',
};

// 11. FAQ
export const faq = {
  eyebrow: 'DU VET EXAKT VAD DU FÅR',
  title: 'NÅGRA FRÅGOR INNAN DU KLIVER UPP PÅ MATTAN.',
  sub: 'Gjord för tränare och klubbägare som tränar barn. En färdig passbok, ingen videokurs.',
  items: [
    {
      q: 'Vad är den här produkten exakt?',
      a: 'En pdf-bok på svenska: en 52-veckorsplan (varje vecka har starten på ett pass, en färdig lek eller övning på 10 minuter, eller en streckgradering) och 10 kompletta barnpass på 45 minuter med 3 sidor vardera, plus dina verktyg som tränare och 5 bonusar.',
    },
    {
      q: 'Vilka stilar passar den för?',
      a: 'För stilar med slag och sparkar som lärs ut till barn: karate, taekwondo, kickboxning, thaiboxning och blandade program. Teknikerna har allmänna namn (framspark, jabb, högt block), och varje pass påminner dig om att använda din stils namn, etikett och bältesordning.',
    },
    {
      q: 'Vilken ålder är den för?',
      a: 'För barn från ungefär 4 till 12 år. Varje pass har ett kort för åldersnivå för 4–6, 7–9 och 10–12 år, så att det funkar även i blandade grupper.',
    },
    {
      q: 'Blir det sparring eller kontakt?',
      a: 'Det blir ingen sparring. Barnen slår och sparkar på mittsar, mål och i luften. Partnerövningar bara med lätt, kontrollerad kontakt på mittsarna och alltid under uppsikt. Fall övas bara på mattor, från en låg position.',
    },
    {
      q: 'Lär sig barnen självförsvar i säkerhetspasset?',
      a: 'Pass 09 lär ut enkla, mjuka frigöringar från grepp och säkerhetsregler: stanna med din grupp, använd en stark röst och berätta för en trygg vuxen. Det är inget löfte om att ett barn kan försvara sig i alla situationer.',
    },
    {
      q: 'Hur får jag den?',
      a: 'Efter betalningen får du tillgång via den e-postadress du anger i kassan. Inget skickas hem. Använd en e-postadress du kommer åt och titta i skräpposten vid behov.',
    },
    {
      q: 'Kan jag använda passen var för sig?',
      a: 'Ja. Varje pass fungerar fristående: du kan börja med passet som dina barn behöver nu, eller följa 52-veckorsplanen från vecka 1.',
    },
    {
      q: 'Kan jag skriva ut den?',
      a: 'Ja. Sidorna är lätta att läsa på mobilen eller surfplattan bredvid mattan, och passplaneraren och strecköversikten är klara att skriva ut.',
    },
    {
      q: 'Får jag dela den med mina tränare?',
      a: 'Det här köpet är för ditt eget bruk som tränare. Att dela med flera klubbar, sprida eller sälja vidare ingår inte i erbjudandet.',
    },
    { q: 'Är det en prenumeration?', a: 'Nej. Du betalar 299 kr en gång.' },
    { q: 'Hur fungerar garantin?', a: 'Du har 10 dagar på dig att be om pengarna tillbaka, utan krångel.' },
  ],
};

// 12. FINAL CTA
export const finalCta = {
  eyebrow: 'TILL NÄSTA GÅNG DU UNDRAR ”VAD SKA JAG GÖRA MED BARNEN I KVÄLL?”',
  title: 'KLIV UPP PÅ MATTAN I DAG MED ETT FÄRDIGT PASS.',
  text: 'Slå upp veckans sida. Förbered dig på 5 minuter. Kör ett pass som barnen gärna kommer tillbaka till.',
  microcopy: '52-veckorsplan + 10 kompletta pass + 5 bonusar · 299 kr, engångsbetalning',
};

// 13. FOOTER
export const footer = {
  line: 'KAMPSPORT KIDS READY™ · Träningsmaterial för tränare. Följ alltid din stils regler och din dojos säkerhetsregler.',
  supportLabel: 'Kundtjänst:',
  supportEmail: 'support@stockdigital.shop',
  copyright: '© 2026',
};
